import { MapLatLng } from '../models/map.latlng';
import { MapPolyline } from '../models/map.polyline';
import { MapPolylinePoint } from '../models/map.polylinePoint';
import { GMapComponent } from './gmap.component';

declare var google: any;

export class GPolyline extends MapPolyline {
    private gMap: GMapComponent;

    constructor(id: number, map: any, color: string, opacity: number, weight: number, clickable: boolean, gMap: GMapComponent) {
        super(id, map, color, opacity, weight);
        this.gMap = gMap;
        this.polyline = new google.maps.Polyline({
            strokeColor: color,
            strokeOpacity: opacity,
            strokeWeight: weight,
            clickable: clickable,
            geodesic: true
        });
        this.polyline.setMap(this.map);
    }

    addPoint(id: number, content: string, position: MapLatLng): MapPolylinePoint {
        const point = new MapPolylinePoint(id, content, position);
        this.polyline.getPath().push(new google.maps.LatLng(point.point.lat, point.point.lng));
        this.points.push(point);
        return point;
    }

    remove() {
        this.polyline.setMap(null);
    }

    // Devuelve el punto de la polininea más cercano a un punto dado
    getNearbyPoint(position: any): any {
        let res: MapPolylinePoint | undefined;
        let i = 0, index = 0;
        let oldDist = 99999999;
        let lastPoint: MapPolylinePoint | undefined;
        for (i = 0; i < this.points.length; i++) {
            if (lastPoint) {
                const dist = this.gMap.distancePointToSegment(lastPoint.point.lng, lastPoint.point.lat, this.points[i].point.lng,
                    this.points[i].point.lat, position.lng(), position.lat());
                if (dist < oldDist) {
                    index = i;
                    oldDist = dist;
                }
            }
            lastPoint = this.points[i];
        }
        if (index > 0) {
            if (google.maps.geometry.spherical.computeDistanceBetween(position,
                new google.maps.LatLng(this.points[index].point.lat, this.points[index].point.lng)) <
                google.maps.geometry.spherical.computeDistanceBetween(position,
                    new google.maps.LatLng(this.points[index - 1].point.lat, this.points[index - 1].point.lng))) {
                res = this.points[index];
            } else {
                res = this.points[index - 1];
            }
        }
        return res;
    }

}
